module.exports = __webpack_public_path__ + "media/svg/do-38bc7149.svg";